import { uploadData } from 'aws-amplify/storage';
import { v4 as uuidv4 } from 'uuid';
import { alertAuthExpired, getFfdUrl } from 'shared/api/ffdClient';

export const submitStudyStart = async (
  yamlConfig: string,
  authToken: string,
  cognitoId: string,
): Promise<void> => {
  // Generate random file names
  const yamlFileName = `${uuidv4()}.yml`;
  const yamlFilePath = `from-web-app/${cognitoId}/bo-config/${yamlFileName}`;

  // Upload YAML file to S3
  try {
    const task = uploadData({
      path: yamlFilePath,
      data: yamlConfig
    });
    await task.result;
  } catch (error) {
    alert("Failed to upload .YAML to the server.");
  }

  // Send API request using uploaded YAML file
  try {
    const response = await fetch(getFfdUrl("/studies/start"), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': authToken,
      },
      body: JSON.stringify({ yamlFilePath }),
    });

    const data = await response.json();
    alert(data.text);
  } catch (error) {
    alertAuthExpired();
  }
};
